import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Paper, Select, MenuItem, Grid } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Line, Chart } from 'react-chartjs-2'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'

import 'react-day-picker/lib/style.css'
import { styles } from '../../classes/Styles'

import './HomeGenreInterestComponent.scss'
import { FILTER_OUT_GENRES } from '../../constants/labels'

import { GENRE_INTEREST } from '../../constants/module_info'

class HomeGenreInterestComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    homepage: PropTypes.string,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    screenWidth: PropTypes.number,
    handleGenreModuleChange: PropTypes.func
  }

  render () {
    const { classes, homepage, metrics, handleGenreModuleChange } = this.props

    return (
      <Paper className={classes.paper}>
        <Grid container spacing={1} direction="column">
          <Grid item>
            <Grid container>
              <Grid item xl={10} lg={9} md={9} sm={9} xs={9}>
                <span className={classes.cardTitle}>Genre Interest</span>
                <OverlayTrigger overlay={<Tooltip id="tooltip">{GENRE_INTEREST}</Tooltip>} placement="right">
                  <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
                </OverlayTrigger>
              </Grid>
              <Grid item xl={2} lg={3} md={3} sm={3} xs={3} className={classes.anticipationType}>
                <img className={classes.anticipationArrow} onClick={handleGenreModuleChange} src="/static/images/antiLeft.png" alt="antiLeft"/>
                <img className={classes.anticipationArrow} onClick={handleGenreModuleChange} src="/static/images/antiRight.png" alt="antiRight"/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.cardSubTitle}>{homepage} engagers interest in different genres over time</Grid>
        </Grid>
        { (metrics && metrics.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (metrics && metrics.details) &&
          <Grid className={classes.genreInterestChartRow}>
            <GenreInterest classes={classes} metrics={metrics}/>
          </Grid>
        }
      </Paper>
    )
  }
}
class GenreInterest extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      genres: [],
      genreInterests: [],
      line1: null,
      line2: null,
      line3: null
    }
  }

  componentDidMount () {
    this.makeChartData()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.metrics !== this.props.metrics && this.props.metrics.details) {
      this.makeChartData()
    }
  }

  makeChartData = () => {
    let genreInterests = this.props.metrics.details && this.props.metrics.details.genre_interest.genre_interests
    genreInterests.map(genre => {
      genre.genre_profile = genre.genre_profile.filter(f => FILTER_OUT_GENRES.indexOf(f.col) < 0)
    })
    const genres = genreInterests[genreInterests.length-1].genre_profile.map(genre => genre.col)
    let genreInterestList = []
    let genreInterestFinalArray = []
    let score = null
    let date = null
    genres.map(g=> {
      genreInterestList = []
      genreInterests.map(interest => {
        for (let i=0; i<interest.genre_profile.length; i++) {
          score = null
          if (interest.genre_profile[i].col === g) {
            score = interest.genre_profile[i].score
            break
          }
        }
        date = interest.year_month.replace(/\b(\d{1})\b/g, '0$1')
        const gi = {
          year_month: moment(new Date(date).toISOString(), 'YYYY-M').format('MMM YYYY'),
          date: moment(new Date(date).toISOString(), 'YYYY-M'),
          genre: g,
          score: score
        }
        genreInterestList.push(gi)
      })
      genreInterestList.sort(function (a, b){
        return (b.date < a.date) ? 1 : (b.date > a.date) ? -1 : 0
      })
      genreInterestFinalArray.push({
          genre: g,
          year: genreInterestList.filter(r => r.genre === g).map(y => y.year_month),
          score: genreInterestList.filter(r => r.genre === g).map(y => y.score)
      })
    })
    this.setState ({
      genres: genres,
      genreInterests: genreInterestFinalArray,
      line1: genreInterestFinalArray[0],
      line2: genreInterestFinalArray[1],
      line3: genreInterestFinalArray[2]
    })
  }

  render () {
    if (! this.state.line1 || ! this.state.line2 || ! this.state.line2) {
      return null
    }
    const { classes } = this.props
    const val = [...this.state.line1.score, ...this.state.line2.score, ...this.state.line3.score]
    const maxVal = Math.max.apply(Math, val)
    const chartMaxValue = maxVal <= 5 ? 5 : Math.ceil(maxVal/10) * 10
    const data = {
      labels: this.state.line1 ? this.state.line1.year : [],
      datasets: [
        {
          label: this.state.line1 ? this.state.line1.genre : '',
          legend: false,
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#8000FF',
          borderColor: '#8000FF',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#8000FF',
          pointBackgroundColor: '#8000FF',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#8000FF',
          pointHoverBorderColor: '#8000FF',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: this.state.line1 ? this.state.line1.score : []
        },
        {
          label: this.state.line2 ? this.state.line2.genre : '',
          legend: false,
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#00D5E2',
          borderColor: '#00D5E2',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#00D5E2',
          pointBackgroundColor: '#00D5E2',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#00D5E2',
          pointHoverBorderColor: '#00D5E2',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: this.state.line2 ? this.state.line2.score : []
        },
        {
          label: this.state.line3 ? this.state.line3.genre : '',
          legend: false,
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#FF7A00',
          borderColor: '#FF7A00',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#FF7A00',
          pointBackgroundColor: '#FF7A00',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#FF7A00',
          pointHoverBorderColor: '#FF7A00',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: this.state.line3 ? this.state.line3.score : []
        }
      ]
    }
    const options = {
      animation: false,
      width: '80%',
      maintainAspectRatio: true,
      responsive: true,
      legend: {
        display: false
      },
      tooltips: {
        enabled: true,
        //yAlign: 'bottom',
        mode: 'label',
        titleFontSize: 10,
        bodyFontSize: 10,
        position: 'custom',
        callbacks: {
          title: (tooltipItem, data) => {
            return data.labels[tooltipItem[0].index]
          },
          label: (tooltipItem, data) => {
            var datasetLabel = data.datasets[tooltipItem.datasetIndex].label
            var label = tooltipItem.value + '%'
            return datasetLabel + ': ' + label
          }
        }
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: true,
            drawBorder: false
          },
          ticks: {
            display: true,
            fontSize: 12,
            fontColor: '#E5E5E5',
            fontFamily: 'Uni Sans Regular',
            callback: function (label) {
              return label > 0 ? label + '% ' : label
            },
            max: chartMaxValue,
            min: 0,
            stepSize: chartMaxValue <= 5 ? 1
              : chartMaxValue <= 10 ? 2
              : chartMaxValue <= 20 ? 4
              : chartMaxValue <= 30 ? 6
              : chartMaxValue <= 40 ? 8
              : chartMaxValue <= 50 ? 10 : 20
          }
        }],
        xAxes: [{
          ticks: {
            fontSize: 12,
            fontColor: '#A7A9AC',
            fontFamily: 'Uni Sans Regular',
            callback: function (label) {
              return label.split(' ')[0]
            }
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }]
      }
    }
    const datasetKeyProvider = () => { return Math.random() }
    const handleChange = (event, index) => {
      if (index === 1) {
        this.setState({ line1: this.state.genreInterests.filter(f => f.genre === event.target.value)[0]})
      } else if (index === 2) {
        this.setState({ line2: this.state.genreInterests.filter(f => f.genre === event.target.value)[0]})
      } else if (index === 3) {
        this.setState({ line3: this.state.genreInterests.filter(f => f.genre === event.target.value)[0]})
      }
    }
    Chart.Tooltip.positioners.custom = (elements, position) => {
      if (!elements.length) {
        return false
      }
      var offset = 0
      //adjust the offset top or bottom depending on the event position
      if (elements[0]._chart.height / 2 > position.y) {
        offset = -30
      } else {
        offset = 30
      }
      return {
        x: position.x,
        y: position.y + offset
      }
    }
    return (
      <Grid className={classes.genreInterestChart}>
        <Line data={data} options={options} height={65} datasetKeyProvider={datasetKeyProvider}/>
        <div className='rowLegend'>
          <Select
            labelId="select-filled-label"
            id="select-filled"
            value={this.state.line1.genre}
            className='selectGenre'
            onChange={(e) => handleChange(e, 1)}
          >
            { this.state.genres.map(genre => {
              return (
                <MenuItem value={genre} key={genre}>
                  <span className='legend1'></span>
                  <span className={classes.selectedGenreText}>{genre}</span>
                </MenuItem>
            )
          })}
          </Select>
          <Select
            labelId="select-filled-label"
            id="select-filled"
            value={this.state.line2.genre}
            className='selectGenre'
            onChange={(e) => handleChange(e, 2)}
          >
            { this.state.genres.map(genre => {
              return (
                <MenuItem value={genre} key={genre}>
                  <span className='legend2'></span>
                  <span className={classes.selectedGenreText}>{genre}</span>
                </MenuItem>
            )
          })}
          </Select>
          <Select
            labelId="select-filled-label"
            id="select-filled"
            value={this.state.line3.genre}
            className='selectGenre'
            onChange={(e) => handleChange(e, 3)}
          >
            { this.state.genres.map(genre => {
              return (
                <MenuItem value={genre} key={genre}>
                  <span className='legend3'></span>
                  <span className={classes.selectedGenreText}>{genre}</span>
                </MenuItem>
            )
          })}
          </Select>
        </div>
      </Grid>
    )
  }
}

export default withStyles(styles)(HomeGenreInterestComponent)